import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { RxCross1 } from "react-icons/rx";
import { useFormik } from "formik";
import * as Yup from "yup";
import SelectInput from "../../SelectInput/SelectInput";
import { HttpService } from "../../../service/HttpService";
import { useAuth } from "../../../context/AuthProvider";
import { Tab, Tabs } from "@mui/material";
import { toast } from "react-toastify";

const FullSwapModal = ({ open, onClose, onSave, scheduleTaskId, taskId, rowData }) => {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [units, setUnits] = useState([]);
  const [epicenterTab, setEpicenterTab] = useState(0);
  const [tabDrafts, setTabDrafts] = useState({
    E1: null,
    E2: null,
    E3: null,
  });

  const getTabKey = (tabIndex) => {
    if (tabIndex === 0) return "E1";
    if (tabIndex === 1) return "E2";
    return "E3";
  };

  const formik = useFormik({
    initialValues: {
      unit: "",
      epicenter: 0,
    },

    validationSchema: Yup.object({
      unit: Yup.string().trim(),
      epicenter: Yup.number().min(0).max(2),
    }),
    enableReinitialize: false,
    validateOnChange: true,
    onSubmit: async (values) => {
      const epicenterKeys = ["E1", "E2", "E3"];

      const currentKey = getTabKey(epicenterTab);
      const mergedDrafts = {
        ...tabDrafts,
        [currentKey]: {
          unit: values.unit || "",
          epicenter: values.epicenter ?? epicenterTab,
        },
      };
      const currentDraft = mergedDrafts[currentKey];
      if (!currentDraft || !currentDraft.unit) {
        formik.setFieldTouched("unit", true, false);
        formik.setFieldError("unit", "Recipe Name is required");
        return;
      }
      const selections = epicenterKeys
        .map((key, index) => {
          const draft = mergedDrafts[key];
          if (!draft || !draft.unit) return null;
          return {
            epicenter: key,
            full_swap_id: draft.unit === "select" ? null : draft.unit,
            tabIndex: index,
          };
        })
        .filter(Boolean);

      try {
        // const responses = await Promise.all(
        //   selections.map((sel) =>
        //     httpService.post("task/assign-full-swap", {
        //       task_id: taskId,
        //       full_swap_id: sel.full_swap_id,
        //       epicenter: sel.epicenter,
        //     })
        //   )
        // );
        const fullSwaps = selections.map((sel) => ({
          schedule_task_id: scheduleTaskId,
          full_swap_id: sel.full_swap_id,
          epicenter: sel.epicenter,
        }));

        const responses = await httpService.post("task/assign-full-swap", {
          fullSwaps: fullSwaps,
        });


        if (responses && responses.success) {
          toast.success("Full Swap assigned successfully", {
            position: "top-right",
          });
          if (onSave) {
            onSave({
              task_id: scheduleTaskId,
              selections,
            });
          }
          formik.resetForm();
          setTabDrafts({
            E1: null,
            E2: null,
            E3: null,
          });
          if (onClose) onClose();
        }
      } catch (error) {
        console.error("Error assigning full swap:", error);
        toast.error(
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            "Failed to assign full swap",
          {
            position: "top-right",
          }
        );
      }
    },
  });

  const fetchRecipe = () => {
    httpService
      // .get("full-swap/get-full-swap")
      .get("full-swap/get-full-swap-dropdown")
      .then((response) => {
        const list = response?.data || [];
        const mapped = list.map((item) => ({
          id: item.id,
          name: item.recipe_name,
        }));
        setUnits(mapped);
      })
      .catch((error) => {
        console.error("Error fetching recipes for Full Swap:", error);
      });
  };

  useEffect(() => {
    if (open) {
      fetchRecipe();
      setEpicenterTab(0);
      
      const existingSwaps = rowData?.task_full_swaps || [];
     const initialDrafts = {
  E1: { unit: "select", epicenter: 0 },
  E2: { unit: "select", epicenter: 1 },
  E3: { unit: "select", epicenter: 2 },
};
      
      existingSwaps.forEach((swap) => {
        initialDrafts[swap.epicenter] = {
          unit: swap.full_swap_id ?? "select",
          epicenter: swap.epicenter === "E1" ? 0 : swap.epicenter === "E2" ? 1 : 2,
        };
      });
      setTabDrafts(initialDrafts);
      
      const firstTab = initialDrafts.E1;
      formik.resetForm({
        values: {
          unit: firstTab?.unit || "",
          epicenter: firstTab?.epicenter ?? 0,
        },
      });
    }
  }, [open, rowData]);

  const handleClose = () => {
    formik.resetForm();
    setTabDrafts({
      E1: null,
      E2: null,
      E3: null,
    });
    if (onClose) onClose();
  };

  return (
    <Modal
      className="department-modal"
      open={open}
      onClose={handleClose}
      aria-labelledby="fullswap-modal-title"
      aria-describedby="fullswap-modal-description"
    >
      <form onSubmit={formik.handleSubmit}>
        <div className="modal_block">
          <div className="modal_header">
            <div className="modal_title_wrapper">
              <h2 className="modal_title">Full Swap</h2>
            </div>
            <div className="cancel-btn-wrap">
              <RxCross1 onClick={handleClose} />
            </div>
          </div>
          <div className="modal_content">
            <Tabs
              variant="scrollable"
              value={epicenterTab}
              onChange={(e, newValue) => {
                const currentKey = getTabKey(epicenterTab);
                const currentValues = formik.values;

                setTabDrafts((prev) => {
                  const updated = {
                    ...prev,
                    [currentKey]: {
                      unit: currentValues.unit || "",
                      epicenter: currentValues.epicenter ?? epicenterTab,
                    },
                  };

                  const newKey = getTabKey(newValue);
                  const newDraft = updated[newKey];
                  if (newDraft) {
                    formik.setValues({
                      unit: newDraft.unit || "",
                      epicenter: newDraft.epicenter ?? newValue,
                    });
                  } else {
                    formik.setValues({
                      unit: "",
                      epicenter: newValue,
                    });
                  }

                  return updated;
                });

                setEpicenterTab(newValue);
              }}
              sx={{
                backgroundColor: "#fffffc",
                "& .MuiTabs-indicator": {
                  backgroundColor: "#00A272",
                  height: "3px",
                },
                "& .MuiTab-root": {
                  position: "relative",
                  color: "#A1A2A1",
                  fontWeight: 400,
                  fontSize: "16px",
                  textTransform: "none",
                  padding: "12px 20px",
                  marginRight: "8px",
                  "&:not(.Mui-selected)::after": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "3px",
                    backgroundColor: "#C4C4C4",
                  },
                  "&.Mui-selected": {
                    color: "#00A272 !important",
                    fontWeight: 600,
                    backgroundColor: "#E6F6F1",
                    borderRadius: "4px 4px 0 0",
                  },
                },
              }}
            >
              <Tab label="Epicenter 1" />
              <Tab label="Epicenter 2" />
              <Tab label="Epicenter 3" />
            </Tabs>

            <div className="row align-items-center">
                <div className="col-md-3">
                    <div className="form_field_wrapper mb-0">
                        <label>
                         Recipe Name
                         {/* <span style={{ color: "red" }}>*</span> */}
                        </label>
                  </div>
                </div>
              <div className="col-md-9">
                <div className="form_field_wrapper">
                  <SelectInput
                    name="unit"
                    label=""
                    required={false}
                    value={formik.values.unit || ""}
                    options={units}
                    multiple={false}
                    onChange={(event) => {
                      formik.setFieldValue("unit", event.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.unit && formik.errors.unit}
                    displayEmpty
                    enableSelect={false}
                  />
                </div>
              </div>
              <div className="col-md-12">
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button type="button" onClick={handleClose} className="btn btn-border">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
            Assign
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default FullSwapModal;

